<ng-container *ngIf="control">

  <ng-container *ngIf="control.invalid && (control.dirty || control.touched)">
    <div *ngIf="control.errors && control.errors.hasWhiteSpace" class="form-errorMsg">
      <i class="form-errorIcon form-errorIcon_warning"></i>
      {{ 'FORMS.ERROR.NO_WHITE_SPACE' | translate }}
    </div>
  </ng-container>

  <div class="passwordValidation" *ngIf="showCondition">
    <span>{{ 'FORMS.ERROR.PASSWORD_VALIDATION.PLEASE_USE' | translate }}</span>
    <span [ngClass]="{'_invalid': control.errors?.NotAtLeastMinLength}" class="passwordValidation-condition">
      12 {{ 'FORMS.ERROR.PASSWORD_VALIDATION.CHARACTERS' | translate }}
    </span>
    <span>{{ 'FORMS.ERROR.PASSWORD_VALIDATION.OF_WHICH' | translate }}</span>
    <span [ngClass]="{'_invalid': control.errors?.NotAtLeastOneNumber}" class="passwordValidation-condition">
      1 {{ 'FORMS.ERROR.PASSWORD_VALIDATION.NUMBER' | translate }}
    </span>
    <span [ngClass]="{'_invalid': control.errors?.NotAtLeastOneUpperCase}" class="passwordValidation-condition">
      1 {{ 'FORMS.ERROR.PASSWORD_VALIDATION.UPPERCASE' | translate }}
    </span>
    <span [ngClass]="{'_invalid': control.errors?.NotAtLeastOneLowerCase}" class="passwordValidation-condition">
      1 {{ 'FORMS.ERROR.PASSWORD_VALIDATION.LOWERCASE' | translate }}
    </span>
    <span [ngClass]="{'_invalid': control.errors?.NotAtLeastOneSpecialCharacter}" class="passwordValidation-condition">
      1 {{ 'FORMS.ERROR.PASSWORD_VALIDATION.SPECIAL_CHARACTER' | translate }}
    </span>
  </div>
</ng-container>
